// extracted by mini-css-extract-plugin
export default {"container":"FooterMenuContent_container__mmYdw","active":"FooterMenuContent_active__MXuV0"};